module.exports = __webpack_public_path__ + "static/media/9 - Petit Prince - Un été sans amour (Moodoïd Remix).56091da1.mp3";